/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  
  document.addEventListener('theme:variant:change', (event) => {
    const variantButtons = event.target.querySelectorAll('[data-variant-buttons] label');
    const checkedInput = event.target.querySelector('[data-variant-buttons] input:checked');
    
    variantButtons.forEach((button) => button.classList.remove('is-active'));
    
    if (checkedInput) {
      const activeLabel = event.target.querySelector(`label[for="${checkedInput.id}"]`);
      if (activeLabel) activeLabel.classList.add('is-active');
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
